"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Link_1 = require("office-ui-fabric-react/lib/Link");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var ListingLinks = /** @class */ (function (_super) {
    __extends(ListingLinks, _super);
    function ListingLinks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingLinks.prototype.render = function () {
        var links = this.props.listing.doc_urls;
        var content;
        if (links && links.length > 0) {
            content = links.map(function (link) {
                return (React.createElement("div", { key: link.name + link.url },
                    React.createElement(Link_1.Link, { href: link.url, target: link.name }, link.name)));
            });
        }
        else {
            content = React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.info }, "No Links available");
        }
        return (React.createElement("div", { style: { padding: 8 } }, content));
    };
    ListingLinks = __decorate([
        mobx_react_1.observer
    ], ListingLinks);
    return ListingLinks;
}(React.Component));
exports.ListingLinks = ListingLinks;
